import React from 'react';
import { useRef, useEffect } from 'react';
import { useMapViewStore } from '../../hooks/useMapViewStore';
import { useLocation, useNavigate } from 'react-router-dom';

import {
  ALL_WITH_HEADER,
  REDEFINE_PASSWORD,
  SIMPLE_HEADER,
  WEB_HEADERS,
} from './constants';

import { useAuth } from '../../context/AuthContext';
import { useBrandContext } from '../../context/BrandContext';
import { useHeaderContext } from '../../context/HeaderContext';

import HeaderBasicLayout from './headerBasicLayout/HeaderBasicLayout';

import { isAppleDevice, isWebView } from '../../utils/detectWebContainer';

import './Header.css';

const Header: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const currentPath = location.pathname.split('/')[2] || '';

  const { user } = useAuth();
  const { brandBgColor, brandName } = useBrandContext();
  const { headerConfig } = useHeaderContext();

  const appleDevice = isAppleDevice();
  const webView = isWebView();
  const { setHeaderHeight, setHeaderRef } = useMapViewStore();
  const _headerRef = useRef<any>();

  const authContext = useAuth();

  // useEffect(() => {
  //   setHeaderHeight(_headerRef.current?.clientHeight);
  //   setHeaderRef(_headerRef);
  // }, [authContext.user]);

  const backNavigation = () => navigate(-1);

  const closeNavigation = () => navigate(`/${brandName}`);

  const renderHeaderContent = () => {
    if (REDEFINE_PASSWORD.includes(currentPath)) {
      return <HeaderBasicLayout />;
    }

    if (SIMPLE_HEADER.includes(currentPath)) {
      return (
        <HeaderBasicLayout
          headerText={''}
          showLogo={false}
          showActionButtons={true}
          backNavigation={backNavigation}
          closeNavigation={closeNavigation}
          user={user}
          {...headerConfig}
        />
      );
    }
  };

  if (!ALL_WITH_HEADER.includes(currentPath)) {
    return null;
  }

  return (
    <div
      style={{
        backgroundColor: brandBgColor,
        position: 'relative',
        zIndex: 2,
        ...(webView && appleDevice ? { paddingTop: 35 } : {}),
      }}
      className={`header-main-container${
        WEB_HEADERS.includes(currentPath)
          ? ' header-main-container-wrapper'
          : ''
      }`}
    >
      {renderHeaderContent()}
    </div>
  );
};

export default Header;
